module.exports = __webpack_public_path__ + "static/media/binary-file-icon.18636f88.png";